import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BlueButton from "./BlueButton";
import { BRAND } from "../css/brand";

export default function GoBackButton({ label = "Go Back" }) {
  const navigate = useNavigate();

  return (
    <BlueButton brand={BRAND}
      onClick={() => navigate(-1)}
      className="flex items-center gap-2"
    >
      <ArrowLeft className="w-4 h-4" />
      {label}
    </BlueButton>
  );
}
